import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import MeetingsList from '../../base/react/components/web/MeetingsList';
import { parseURIString, safeDecodeURIComponent } from '../../base/util/uri';
import { deleteRecentListEntry } from '../actions';
import { isRecentListEnabled, toDisplayableList } from '../functions.web';
import AbstractRecentList from './AbstractRecentList';
/**
 * The cross platform container rendering the list of the recently joined rooms.
 *
 */
class RecentList extends AbstractRecentList {
    /**
     * Initializes a new {@code RecentList} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this.state = {
            transcriptionStatus: {}
        };
        this._onItemDelete = this._onItemDelete.bind(this);
        this._onDownloadTranscription = this._onDownloadTranscription.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        super.componentDidMount();
        this._fetchTranscriptionStatus();
    }
    /**
     * Fetches transcription status for the recent meetings.
     *
     * @private
     * @returns {void}
     */
    _fetchTranscriptionStatus() {
        const { _recentList } = this.props;
        if (!_recentList || _recentList.length === 0) {
            return;
        }
        const roomNames = _recentList.map(item => safeDecodeURIComponent(parseURIString(item.conference).room));
        let backendUrl = window.config?.backendUrl;
        if (!backendUrl || (backendUrl.includes('localhost') && !window.location.hostname.includes('localhost'))) {
            backendUrl = window.location.origin;
        }
        const finalBackendUrl = backendUrl.endsWith('/') ? backendUrl.slice(0, -1) : backendUrl;
        fetch(`${finalBackendUrl}/api/transcriptions/status`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ meeting_ids: roomNames })
        })
            .then(res => res.json())
            .then(data => {
            if (data.status === 'success' && data.results) {
                this.setState({ transcriptionStatus: data.results });
            }
        })
            .catch(err => console.error('Failed to fetch transcription status:', err));
    }
    /**
     * Handles downloading transcription.
     *
     * @param {Object} meeting - The meeting object.
     * @param {string} format - The download format.
     * @private
     * @returns {void}
     */
    _onDownloadTranscription(meeting, format) {
        let backendUrl = window.config?.backendUrl;
        if (!backendUrl || (backendUrl.includes('localhost') && !window.location.hostname.includes('localhost'))) {
            backendUrl = window.location.origin;
        }
        const finalBackendUrl = backendUrl.endsWith('/') ? backendUrl.slice(0, -1) : backendUrl;
        window.open(`${finalBackendUrl}/api/transcription/${meeting.title}/download/${format}`, '_blank');
    }
    /**
     * Deletes a recent entry.
     *
     * @param {Object} entry - The entry to be deleted.
     * @inheritdoc
     */
    _onItemDelete(entry) {
        this.props.dispatch(deleteRecentListEntry(entry));
    }
    /**
     * Implements the React Components's render method.
     *
     * @inheritdoc
     */
    render() {
        if (!isRecentListEnabled()) {
            return null;
        }
        const { disabled, _recentList } = this.props;
        const { transcriptionStatus } = this.state;
        const recentList = toDisplayableList(_recentList).map(item => ({
            ...item,
            hasTranscription: Boolean(transcriptionStatus[item.title])
        }));
        return (React.createElement(MeetingsList, { disabled: Boolean(disabled), hideURL: true, listEmptyComponent: this._getRenderListEmptyComponent(), meetings: recentList, onDownloadTranscription: this._onDownloadTranscription, onItemDelete: this._onItemDelete, onPress: this._onPress }));
    }
}
/**
 * Maps redux state to component props.
 *
 * @param {Object} state - The redux state.
 * @returns {{
 *     _defaultServerURL: string,
 *     _recentList: Array
 * }}
 */
export function _mapStateToProps(state) {
    return {
        _recentList: state['features/recent-list']
    };
}
export default translate(connect(_mapStateToProps)(RecentList));
